/**
 * claims module route path constants.
 *
 * Mirrors `modules/financialClearance/routes/routeConfig.ts`: all claims paths are declared here
 * so App routing, in-app navigation, and path builders share one source of truth.
 */
export const CLAIMS_BASE_PATH = '/claims';
export const CLAIMS_QUEUE_PATH = '/claims/queue';
export const CLAIMS_EXCEPTIONS_PATH = '/claims/exceptions';
export const CLAIMS_MISSED_FINDINGS_PATH = '/claims/missed-findings';
export const CLAIMS_DETAIL_PATH = '/claims/:claimId';
export const claimDetailPath = (claimId: string): string => `/claims/${claimId}`;
export const CLAIMS_LINKED_CLAIM_DETAIL_PATH = '/claims/:claimId/claims/:linkedClaimId';
export const linkedClaimDetailPath = (caseId: string, linkedClaimId: string): string =>
  `/claims/${caseId}/claims/${linkedClaimId}`;
